"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultTheme = {
  MuiToolbar: {
    root: {
      display: 'flex',
      zIndex: '120',
      minHeight: '25px',
      borderTop: '2px solid #e7e5e5',
      alignItems: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      justifyContent: 'space-between',
      backgroundColor: '#ffffff'
    },
    regular: {
      '@media (min-width: 600px)': {
        minHeight: '25px'
      }
    }
  }
};
var CustomToolbar = function CustomToolbar(_ref) {
  var numSelected = _ref.numSelected,
    _ref$customTheme = _ref.customTheme,
    customTheme = _ref$customTheme === void 0 ? {} : _ref$customTheme;
  return /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
    theme: (0, _core.createTheme)({
      overrides: _objectSpread(_objectSpread({}, defaultTheme), customTheme)
    })
  }, numSelected > 0 && /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "div"
  }, "".concat(numSelected, " row(s) selected"))));
};
CustomToolbar.propTypes = {
  numSelected: _propTypes.default.number.isRequired
};
var _default = CustomToolbar;
exports.default = _default;